import { CountUp } from 'countup.js';
import Alpine from 'alpinejs';

export default function initProgressBarDash() {
  Alpine.data('progressBarDash', () => ({
    init() {
      // @ts-ignore
      const chart = this.$el.querySelector('.progress-chart');
      const observer = new IntersectionObserver((entries, obs) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && entry.intersectionRatio >= 0.7) {
            const svg = entry.target.querySelector('svg');
            if (svg && !svg.classList.contains('progress-animate')) {
              svg.classList.add('progress-animate');
              svg.dataset.animated = 'true';
              obs.unobserve(entry.target);
            }
          }
        });
      }, { threshold: 0.7 });
      observer.observe(chart as HTMLElement);
      this.loadCountersCards();
    },
    instanceCountUp(item: HTMLElement) {
      const { prefix, suffix, number } = item.dataset;
      const options = {
        prefix,
        suffix,
        duration: 4,
        useEasing: true,
      };
      const getValue = Number(number);
      if (getValue > 0) {
        const countUpInstance = new CountUp(item, getValue, options);
        countUpInstance.start();
      }
    },
    loadCountersCards() {
      const counterCardsContent = this.$el;

      const observer = new IntersectionObserver(
        (entries, observerInstance) => {
          entries.forEach((entry) => {
            const cardsProgressItem = entry.target.querySelector('.donutchart__counter');
            if (entry.isIntersecting && entry.intersectionRatio >= 0.7) {
              this.instanceCountUp(cardsProgressItem as HTMLElement);
              observerInstance.unobserve(entry.target);
            }
          });
        },
        {
          threshold: 0.7,
        },
      );

      observer.observe(counterCardsContent);
    },
  }));
}
